<div class="campaign-history">
  <section class="campaign-card">
    <div class="campaign-card__header">
      <div>
        <h2>Detalhes da Campanha</h2>
      </div>
    </div>

    <div class="campaign-details" *ngIf="campaign">
      <div *ngIf="campaign.coverUrl" class="campaign-cover-section">
        <div class="campaign-cover-preview">
          <img [src]="campaign.coverUrl" alt="Capa da campanha" />
        </div>
      </div>
      <div>
        <span class="campaign-details__label">Nome da campanha</span>
        <span class="campaign-details__value">{{ campaign.name }}</span>
      </div>
      <div>
        <span class="campaign-details__label">Descrição Interna</span>
        <span class="campaign-details__value">{{ campaign.description || '-' }}</span>
      </div>
      <div>
        <span class="campaign-details__label">Validade</span>
        <span class="campaign-details__value">
          {{ campaign.startDate | date: 'dd/MM/yyyy' }} -
          {{ campaign.endDate | date: 'dd/MM/yyyy' }}
        </span>
      </div>
      <div>
        <span class="campaign-details__label">Status</span>
        <span class="campaign-details__value">{{ campaign.status }}</span>
      </div>
    </div>

    <div class="campaign-card__header">
      <div>
        <h2>Métricas de Execução</h2>
      </div>
    </div>

    <div class="totals">
      <div class="dashboard-card">
        <span class="header">Total de Envios</span>
        <span class="value">{{ historySummary?.totalGiftsSent || 0 }}</span>
      </div>
      <div class="dashboard-card">
        <span class="header">Envios Avulso</span>
        <span class="value">{{ historySummary?.totalGiftsSentAvulso || 0 }}</span>
      </div>
      <div class="dashboard-card">
        <span class="header">Envios com Edição</span>
        <span class="value">{{ historySummary?.totalGiftsSentEdition || 0 }}</span>
      </div>
      <div class="dashboard-card">
        <span class="header">Valor Assinaturas</span>
        <span class="value">{{ (historySummary?.subscriptionValue || 0) | currency: 'BRL' }}</span>
      </div>
      <div class="dashboard-card">
        <span class="header">Custo Brindes</span>
        <span class="value">{{ (historySummary?.giftValue || 0) | currency: 'BRL' }}</span>
      </div>
      <div class="dashboard-card">
        <span class="header">Custo Frete</span>
        <span class="value">{{ (historySummary?.freightValue || 0) | currency: 'BRL' }}</span>
      </div>
      <div class="dashboard-card">
        <span class="header header--success">Valor Líquido</span>
        <span class="value">{{ (historySummary?.netValue || 0) | currency: 'BRL' }}</span>
      </div>
    </div>

    <div class="campaign-card__header" *ngIf="gifts.length">
      <div>
        <h2>Brindes Enviados</h2>
      </div>
    </div>

    <div class="gift-list" *ngIf="gifts.length">
      <div class="gift-card" *ngFor="let gift of gifts">
        <div class="gift-card__info">
          <div class="gift-card__label">Produto</div>
          <div class="gift-card__title">{{ gift.validation?.productVariantName || gift.productVariantId || gift.internalEan }}</div>
          <div class="gift-card__subtitle">EAN: {{ gift.internalEan }}</div>
        </div>
        <div class="gift-card__meta">
          <div>
            <div class="gift-card__label">Qtd</div>
            <div class="gift-card__value">{{ gift.quantity || 0 }}</div>
          </div>
          <div>
            <div class="gift-card__label">Custo Unit.</div>
            <div class="gift-card__value">{{ (gift.costPrice || 0) | currency: 'BRL' }}</div>
          </div>
          <div>
            <div class="gift-card__label">Preço NF</div>
            <div class="gift-card__value">{{ (gift.invoicePrice || 0) | currency: 'BRL' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="campaign-card__header">
      <div>
        <h2>Lista de Beneficiados</h2>
      </div>
    </div>

    <app-table
      #historyTable
      [lazy]="false"
      [cols]="columns"
      [elements]="filteredCustomers()"
      [defaultRows]="25"
      [sortField]="'personId'"
      [modelName]="reportModelName"
      [addButton]="false"
      [exportExcel]="false"
      [exportPdf]="false"
      [extraButton]="true"
      [extraLabel]="'Gerar relatório XLSX'"
      [extraButtonIcon]="'pi pi-download'"
      [extraButtonTooltip]="'Exportar beneficiados em XLSX'"
      (extraButtonClick)="exportHistoryReport()"
      [captionTemplate]="searchTemplate"
    ></app-table>

    <ng-template #searchTemplate>
      <form class="form-b4a campaign-table-filters" [formGroup]="filterForm">
        <span class="p-float-label">
          <input
            pInputText
            id="customerSearch"
            formControlName="search"
            (input)="updateSearch()"
          />
          <label for="customerSearch">E-mail, ID ou Pedido</label>
        </span>
      </form>
    </ng-template>
  </section>
</div>
